<script>
/**
 * ****************************************************************************
 * @description     :   List Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of list component
 */
var AnsPanelHeader = {
    template: template,
    props: {
        label: String,
        subLabel: String,
        panelClass: String,
        modelValue: String | Number,
        onChange: Function
    },
    emits: ['update:modelValue'],
    data() {
        return {
            vewValue: ''
        };
    },
    mounted() {
        this.vewValue = this.modelValue ? this.modelValue : this.value;
    },
    methods: {
        /**
         * select item in table
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params : value
         * @access : private
         */
        selectedOption(val) {
            return this.vewValue == val;
        },
        /**
         * updated item in table
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params : value
         * @access : private
         */
        updateInput(val) {
            this.vewValue = val;
            this.$emit('update:modelValue', this.vewValue);
            if (this.onChange) {
                this.onChange(this.vewValue);
            }
        }
    }
};
export default AnsPanelHeader;
</script>
